module.exports = __webpack_public_path__ + "9a7a45e57d41dcad03f531196c17282a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/guitar-button-pressed-background.png
// module id = 38
// module chunks = 0